// The calendar's shared vocabulary: the values the server's constants/calendar.js defines,
// plus the handful of derived questions every part of the screen asks about a meeting.
//
// Mirrored here rather than imported because the client cannot import from the server —
// but nothing is RE-IMPLEMENTED. `held` and `cancelled` are computed on the server and
// arrive on the row (see meetings/shape.js); these helpers only read them. The client
// never decides whether a meeting has been held, only how to draw one that has.
import { WORK_START, WORK_END, SLOT_MINUTES } from './workingDay';

// 'external' (077): with someone outside the system, named as typed.
export const MEETING_KIND = { CLIENT: 'client', INTERNAL: 'internal', EXTERNAL: 'external' };
export const MEETING_STATUS = { SCHEDULED: 'scheduled', CANCELLED: 'cancelled' };

export const isInternal = (m) => m.kind === MEETING_KIND.INTERNAL;
export const isExternal = (m) => m.kind === MEETING_KIND.EXTERNAL;
export const isCancelled = (m) => m.status === MEETING_STATUS.CANCELLED;
export const isHeld = (m) => m.held === true;

// Does this meeting involve this partner at all? The mine/partner filter's whole rule, and
// it has to ask BOTH sides: an internal meeting is owned by one partner and held with the
// other, and it belongs on both their calendars.
export const involvesPartner = (m, partnerId) =>
  String(m.owner_partner_id) === String(partnerId)
  || String(m.with_partner_id) === String(partnerId);

// The durations the form offers, from half an hour up to a full working day, on the same
// half-hour grid the server enforces.
export const DURATIONS = (() => {
  const max = WORK_END - WORK_START;
  const out = [];
  for (let d = SLOT_MINUTES; d <= max; d += SLOT_MINUTES) out.push(d);
  return out;
})();
